import Vue from "vue";
import VueI18n from "vue-i18n";
import getCategories from "../../lib/find-categories";
import encodeQueryData from "../../lib/encode-query-data";
import createLang from "../../search-teaser_lang";
import "./SearchTeaser.sass";
import { appendCurrentParamsToURL } from "@/helpers/commonHelper";

// language stuff
Vue.use(VueI18n);
const i18n = createLang();

export default {
  name: "search-teaser",
  props: {
    id: {
      type: String,
      default: "eoev-search-teaser"
    },
    listUri: {
      type: String,
      required: true
    },
    locale: {
      type: String,
      default: "de-DE"
    },
    firstDayOfWeek: {
      type: Number,
      default: 1
    },
    apiUrl: {
      type: String,
      required: true
    },
    apiKey: {
      type: String,
      required: true
    }
  },
  created() {
    // set locale globally
    this.$vuetify.lang.current = this.locale;

    // load categories
    const that = this;
    getCategories(this.apiUrl, this.apiKey)
      .then(data => {
        const categories = [];

        if (data) {
          data.forEach(category => {
            categories.push({ text: category.title, value: category._id });
          });
        }

        that.categories = categories;
      })
      .catch(() => {})
      .finally(() => {
        that.loadingCategories = false;
      });
  },
  data: () => ({
    dates: [
      // holds actual dates
      "",
      ""
    ],
    category: "",
    categories: [], // list
    searchString: "",
    isDatePickerOpen: false,
    loadingCategories: true
  }),
  computed: {
    dateRangeText() {
      if (this.dates[0] && this.dates[1]) {
        if (this.dates[0] === this.dates[1]) {
          return this.formatDate(this.dates[0]);
        }

        return (
          this.formatDate(this.dates[0]) +
          " – " +
          this.formatDate(this.dates[1])
        );
      }
      return "";
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      // return language formatted date
      return this.$i18n.t("message.dateFormat", [day, month, year]);
    },
    setDateToday() {
      this.isDatePickerOpen = false;
      const calcDate = new Date();
      calcDate.setMinutes(calcDate.getMinutes() - calcDate.getTimezoneOffset()); // remove tz offset
      const date = calcDate.toISOString().substring(0, 10);
      this.dates = [date, date];
    },
    setDateTomorrow() {
      this.isDatePickerOpen = false;
      const calcDate = new Date();
      calcDate.setMinutes(calcDate.getMinutes() - calcDate.getTimezoneOffset()); // remove tz offset
      // add one day
      calcDate.setDate(calcDate.getDate() + 1);
      const date = calcDate.toISOString().substring(0, 10);
      this.dates = [date, date];
    },
    setDateWeekend() {
      this.isDatePickerOpen = false;
      const calcDate = new Date();
      calcDate.setMinutes(calcDate.getMinutes() - calcDate.getTimezoneOffset()); // remove tz offset
      const diffToFriday = 5 - calcDate.getDay();
      switch (diffToFriday) {
        case 5: // Sunday - to last friday
          calcDate.setDate(calcDate.getDate() - 2);
          break;
        default:
          calcDate.setDate(calcDate.getDate() + diffToFriday);
      }
      const date = calcDate.toISOString().substring(0, 10);
      // to sunday
      calcDate.setDate(calcDate.getDate() + 2);
      const sunday = calcDate.toISOString().substring(0, 10);
      this.dates = [date, sunday];
    },
    clearDates() {
      this.isDatePickerOpen = false;
      this.dates = ["", ""];
    },
    closeOnSecondPick() {
      if (this.dates[0] && this.dates[1]) {
        this.isDatePickerOpen = false;
      }
    },
    // called on form submit
    formSubmit($event) {
      $event.preventDefault();
      $event.stopPropagation();

      // create parameters
      const params = {
        "tx_eoevents_pi1[from_search]": 1 // indicate, that we have come from the search form and want to reset other filters
      };
      if (this.searchString) {
        params["tx_eoevents_pi1[s]"] = this.searchString;
      }
      if (this.category) {
        params["tx_eoevents_pi1[category]"] = this.category;
      }
      if (this.dates[0] && this.dates[1]) {
        params["tx_eoevents_pi1[start]"] = this.dates[0];
        params["tx_eoevents_pi1[end]"] = this.dates[1];
      }

      // redirect
      if (this.listUri) {
        const listUriWithParams = appendCurrentParamsToURL(this.listUri);
        if (this.listUri === listUriWithParams) {
          window.location.href = listUriWithParams + encodeQueryData(params);
        } else {
          const paramsStr = "&" + encodeQueryData(params).substring(1);
          window.location.href = listUriWithParams + paramsStr;
        }
      }
    },
    clearAllData() {
      this.dates = ["", ""];
      this.category = "";
      this.searchString = "";
    }
  },
  i18n
};
